import { useState } from "react";
import { motion } from "framer-motion";
import HairQuiz from "../components/features/HairQuiz";
import ProductCard from "../components/ui/ProductCard";
import { generateRecommendations } from "../utils/recommendationEngine";

export default function HairQuizPage() {
  const [recommendations, setRecommendations] = useState(null);

  const handleQuizComplete = (answers) => {
    const recommendedProducts = generateRecommendations(answers);
    setRecommendations(recommendedProducts);
  };

  return (
    <div className="bg-gray-50 min-h-screen pt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        {!recommendations ? (
          <div className="max-w-4xl mx-auto">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className="text-center mb-12"
            >
              <span className="inline-block px-4 py-1.5 mb-4 text-sm font-medium tracking-wider text-[#DB5461] bg-[#DB5461]/10 rounded-full">
                PERSONALIZED CARE
              </span>
              <h1 className="text-4xl font-serif font-bold text-primary-900 mb-4">
                Find Your Perfect Hair Care Routine
              </h1>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                Take our interactive quiz to get personalized product
                recommendations based on your unique hair type and concerns.
              </p>
            </motion.div>

            <HairQuiz onComplete={handleQuizComplete} />
          </div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="space-y-12"
          >
            <div className="text-center">
              <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                className="w-16 h-16 bg-[#DB5461]/20 rounded-full flex items-center justify-center mx-auto mb-6"
              >
                <span className="text-2xl">✨</span>
              </motion.div>
              <h2 className="text-3xl font-serif font-bold text-primary-900 mb-4">
                Your Personalized Recommendations
              </h2>
              <p className="text-lg text-gray-600 max-w-2xl mx-auto mb-8">
                Based on your hair profile, we've selected these products to
                help you achieve your hair goals.
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {recommendations.map((product) => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>

            <div className="text-center">
              <button
                onClick={() => setRecommendations(null)}
                className="text-[#DB5461] hover:text-[#DB5461]/80 font-medium"
              >
                Retake Quiz
              </button>
            </div>
          </motion.div>
        )}
      </div>
    </div>
  );
}
